import { FormaJuridicaEnum, type CreateEmpresaInmobiliariaModel, type DireccionModel } from "@api/api";

export class CreateEmpresaInmobiliaria implements CreateEmpresaInmobiliariaModel {

  Web: string = '';
  Documento: string = '';
  Telefono: string = '';
  Tipo: string = "INMOBILIARIA";
  RazonSocial: string = '';
  Email: string = '';
  FechaCreacion: Date = new Date(2000, 1, 1);
  RedesSociales: string | null = null;
  Direccion: DireccionModel = {
    CodigoPostal: null,
    Provincia: null,
    Municipio: null,
    TipoVia: null,
    NombreVia: null,
    Numero: null,
    Escalera: null,
    Piso: null,
    Puerta: null
  };
  Iban: string | null = null;
  FormaJuridica: FormaJuridicaEnum | null = null;
  PorcentajeIrpf: number | null = null;
  DiasAutofacturacion: number[] = [];
  ImagenB64: string | null = null;
  LogoPortalB64: string | null = null;
  DenoFactura: string = '';
  TieneWhitelistServicios: boolean = false;
  WhitelistServicios: string[] | null = null;
  MarcoComisiones: string | null = null;
  UsuarioResponsable: string | null = null;
  PuedeTramitarAgua: boolean = true;
  IdComercial: string | null = null;

  constructor(data?: Partial<CreateEmpresaInmobiliaria>) {
    Object.assign(this, data);
  }
}

